import { render, staticRenderFns } from "./NbaScoring.vue?vue&type=template&id=46d88b96&scoped=true"
import script from "./NbaScoring.vue?vue&type=script&lang=js"
export * from "./NbaScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d88b96",
  null
  
)

export default component.exports